// extracted by mini-css-extract-plugin
export default {"RichText":"RichText_RichText__yRukQ"};